(function () {
  var SALE_END = Date.parse('2026-09-01T00:00:00-05:00');
  var SALE_RATE = 0.20;

  function parseMoney(value) {
    var number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function money(cents) {
    var value = cents / 100;
    return '$' + (cents % 100 === 0 ? value.toFixed(0) : value.toFixed(2));
  }

  function formerPrice(currentCents) {
    return Math.round(currentCents / (1 - SALE_RATE));
  }

  function saleTarget() {
    if (document.querySelector('[data-bcf-pdp]')) return '#bcf-buy-form';
    if (document.getElementById('minimal-brand')) return '#minimal-brand';
    return '#grid';
  }

  function addBanner() {
    if (document.querySelector('.bcf-summer-sale')) return;
    var banner = document.createElement('aside');
    banner.className = 'bcf-summer-sale';
    banner.setAttribute('aria-label', 'Summer Sale, 20 percent off all chains through August 31');
    banner.innerHTML = '<a class="bcf-summer-sale__message" href="' + saleTarget() + '"><span class="bcf-summer-sale__eyebrow">Summer Sale</span><strong>20% off all chains</strong><small>Ends August 31 at 11:59 PM CT</small></a>' +
      '<div class="bcf-summer-sale__timer" role="timer" aria-live="off" aria-label="Time remaining in the Summer Sale">' +
      '<span class="bcf-summer-sale__time"><b data-sale-days>00</b><span>Days</span></span>' +
      '<span class="bcf-summer-sale__time"><b data-sale-hours>00</b><span>Hrs</span></span>' +
      '<span class="bcf-summer-sale__time"><b data-sale-minutes>00</b><span>Min</span></span>' +
      '<span class="bcf-summer-sale__time"><b data-sale-seconds>00</b><span>Sec</span></span></div>';
    document.body.insertBefore(banner, document.body.firstChild);
    syncBannerHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncBannerHeight).observe(banner);
    } else {
      window.addEventListener('resize', syncBannerHeight);
    }
  }

  function syncBannerHeight() {
    var banner = document.querySelector('.bcf-summer-sale');
    if (!banner) return;
    document.documentElement.style.setProperty('--bcf-summer-sale-height', Math.ceil(banner.getBoundingClientRect().height) + 'px');
  }

  function updateTimer() {
    var banner = document.querySelector('.bcf-summer-sale');
    if (!banner) return;
    var remaining = Math.max(0, SALE_END - Date.now());
    if (!remaining) {
      document.documentElement.classList.add('summer-sale-ended');
      banner.querySelector('.bcf-summer-sale__message strong').textContent = 'Summer Sale has ended';
      banner.querySelector('.bcf-summer-sale__message small').textContent = 'New pricing begins September 1';
      return;
    }
    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);
    var values = { days: days, hours: hours, minutes: minutes, seconds: seconds };
    Object.keys(values).forEach(function (key) {
      var node = banner.querySelector('[data-sale-' + key + ']');
      if (node) node.textContent = String(values[key]).padStart(2, '0');
    });
  }

  function decorateInlinePrice(node) {
    if (!node || node.dataset.summerPrice === 'true') return;
    var currentText = node.textContent.trim();
    var currentCents = parseMoney(currentText);
    if (currentCents === null) return;
    node.dataset.summerPrice = 'true';
    node.classList.add('summer-inline-price');
    node.setAttribute('aria-label', currentText + ', Summer Sale price, formerly ' + money(formerPrice(currentCents)));
    node.innerHTML = '<span class="summer-inline-price__current">' + currentText + '</span><del class="summer-inline-price__was">' + money(formerPrice(currentCents)) + '</del>' +
      (node.matches('.card .price') ? '<span class="summer-card-badge">20% off</span>' : '');
  }

  function decorateHeroPrice(node) {
    if (!node || node.dataset.summerPrice === 'true') return;
    var match = node.textContent.match(/\$[\d,.]+/);
    if (!match) return;
    var currentCents = Number(node.dataset.priceCents) || parseMoney(match[0]);
    if (currentCents === null) return;
    var compareAtCents = Number(node.dataset.compareAtCents);
    var formerCents = compareAtCents > currentCents ? compareAtCents : formerPrice(currentCents);
    node.dataset.summerPrice = 'true';
    node.setAttribute('aria-label', match[0] + ', Summer Sale price, formerly ' + money(formerCents));
    node.innerHTML = node.textContent.replace(match[0], '<span class="summer-hero-price"><span>' + match[0] + '</span><del>' + money(formerCents) + '</del></span><span class="summer-home-card-badge">20% off</span>');
  }

  function updateMainPrice(current) {
    var price = document.getElementById('p-price');
    if (!price) return;
    var currentCents = current && current.cents ? Number(current.cents) : parseMoney(price.textContent);
    if (!Number.isFinite(currentCents)) return;
    var row = price.closest('.price-row');
    if (!row) return;
    row.classList.add('summer-sale-price-row');
    var compare = row.querySelector('[data-summer-main-compare]');
    if (!compare) {
      compare = document.createElement('del');
      compare.className = 'summer-main-compare';
      compare.dataset.summerMainCompare = 'true';
      price.insertAdjacentElement('afterend', compare);
    }
    compare.textContent = money(formerPrice(currentCents));
    var badge = row.querySelector('.summer-main-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'summer-main-badge';
      badge.textContent = 'Summer Sale · 20% off';
      compare.insertAdjacentElement('afterend', badge);
    }
    row.setAttribute('aria-label', money(currentCents) + ' Summer Sale price, formerly ' + compare.textContent + ', 20 percent off');
  }

  function decoratePrices() {
    document.querySelectorAll('.lens .pr, .card .price').forEach(decorateInlinePrice);
    document.querySelectorAll('.minimal-home-hero__item small').forEach(decorateHeroPrice);
    updateMainPrice();
  }

  function init() {
    addBanner();
    decoratePrices();
    updateTimer();
    window.setInterval(updateTimer, 1000);
    var root = document.querySelector('[data-bcf-pdp]');
    if (root) root.addEventListener('bcf:variant-change', function (event) {
      updateMainPrice(event.detail && event.detail.variant);
    });
    document.addEventListener('bcf:minimal-home-ready', decoratePrices);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
